import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';

var DropdownArrow = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.565 7.885c.489.517 1.381.517 1.87 0l5.177-5.48a1.454 1.454 0 000-1.98 1.268 1.268 0 00-1.87 0L6.515 4.903 2.287.426A1.32 1.32 0 001.337 0C.994 0 .649.152.389.426a1.454 1.454 0 000 1.979l5.177 5.48z",
    fill: "#16CA92"
  }));
});
DropdownArrow.displayName = 'DropdownArrow';

export { DropdownArrow, DropdownArrow as default };
